<div class="webhook-dialog-container">
  <form [formGroup]="form" (ngSubmit)="submitForm()" class="webhook-form">
    <div class="form-header">
      <h3 class="form-title">
        <i class="pi pi-link mr-2"></i>
        Submit Webhook Data
      </h3>
      <p class="form-subtitle">
        Fill in the required fields to submit your webhook
      </p>
    </div>

    <div class="form-content">
      <ng-container formArrayName="fields">
        <div
          *ngFor="let field of allFields; index as i"
          class="form-field-wrapper"
        >
          <div [formGroupName]="i" class="form-field">
            <ng-container [ngSwitch]="field.field_name">
              <!-- Dropdown Fields -->
              <div *ngSwitchCase="'dropdown'" class="field-container">
                <label class="field-label">
                  <i class="pi pi-list mr-2"></i>
                  {{ field.field_title }}
                  <span *ngIf="field.field_required" class="required-indicator"
                    >*</span
                  >
                </label>
                <p-dropdown
                  [options]="field.field_details"
                  placeholder="Select an option"
                  formControlName="value"
                  appendTo="body"
                  class="modern-dropdown"
                  [class.field-error]="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                ></p-dropdown>
                <div
                  *ngIf="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  class="error-message"
                >
                  <i class="pi pi-exclamation-circle mr-1"></i>
                  This field is required
                </div>
              </div>

              <!-- Text Fields -->
              <div *ngSwitchCase="'text'" class="field-container">
                <label class="field-label">
                  <i class="pi pi-pencil mr-2"></i>
                  {{ field.field_title }}
                  <span *ngIf="field.field_required" class="required-indicator"
                    >*</span
                  >
                </label>
                <input
                  pInputText
                  type="text"
                  formControlName="value"
                  class="modern-input"
                  [class.field-error]="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  placeholder="Enter {{ field.field_title }}"
                />
                <div
                  *ngIf="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  class="error-message"
                >
                  <i class="pi pi-exclamation-circle mr-1"></i>
                  This field is required
                </div>
              </div>

              <!-- Number Fields -->
              <div *ngSwitchCase="'number'" class="field-container">
                <label class="field-label">
                  <i class="pi pi-hashtag mr-2"></i>
                  {{ field.field_title }}
                  <span *ngIf="field.field_required" class="required-indicator"
                    >*</span
                  >
                </label>
                <input
                  pInputText
                  type="number"
                  formControlName="value"
                  class="modern-input"
                  [class.field-error]="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  placeholder="Enter {{ field.field_title }}"
                />
                <div
                  *ngIf="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  class="error-message"
                >
                  <i class="pi pi-exclamation-circle mr-1"></i>
                  This field is required
                </div>
              </div>

              <!-- Date Fields -->
              <div *ngSwitchCase="'date'" class="field-container">
                <label class="field-label">
                  <i class="pi pi-calendar mr-2"></i>
                  {{ field.field_title }}
                  <span *ngIf="field.field_required" class="required-indicator"
                    >*</span
                  >
                </label>
                <p-calendar
                  formControlName="value"
                  appendTo="body"
                  dateFormat="yy-mm-dd"
                  placeholder="Select date"
                  [showIcon]="true"
                  class="modern-calendar"
                  [class.field-error]="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                ></p-calendar>
                <div
                  *ngIf="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  class="error-message"
                >
                  <i class="pi pi-exclamation-circle mr-1"></i>
                  This field is required
                </div>
              </div>

              <!-- File Fields -->
              <div *ngSwitchCase="'file'" class="field-container">
                <label class="field-label">
                  <i class="pi pi-file mr-2"></i>
                  {{ field.field_title }}
                  <span *ngIf="field.field_required" class="required-indicator"
                    >*</span
                  >
                </label>
                <p-fileUpload
                  mode="advanced"
                  chooseLabel="Choose File"
                  chooseIcon="pi pi-upload"
                  [showUploadButton]="false"
                  accept=".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  (onSelect)="onFileSelect($event, i)"
                  class="modern-file-upload"
                  [multiple]="true"
                  [maxFileSize]="1073741824"
                  [class.field-error]="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                ></p-fileUpload>
                <p-progressBar
                  *ngIf="uploadProgress !== null"
                  [value]="uploadProgress"
                  styleClass="mt-3 modern-progress-bar"
                ></p-progressBar>
                <div
                  *ngIf="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  class="error-message"
                >
                  <i class="pi pi-exclamation-circle mr-1"></i>
                  This field is required
                </div>
              </div>

              <!-- email fields -->
              <div *ngSwitchCase="'email'" class="field-container">
                <label class="field-label">
                  <i class="pi pi-envelope mr-2"></i>
                  {{ field.field_title }}
                  <span *ngIf="field.field_required" class="required-indicator"
                    >*</span
                  >
                </label>
                <input
                  pInputText
                  type="email"
                  formControlName="value"
                  class="modern-input"
                  [class.field-error]="
                    fields.at(i).get('value')?.invalid &&
                    fields.at(i).get('value')?.touched
                  "
                  placeholder="Enter {{ field.field_title }}"
                />
                <div
                  *ngIf="
                    fields.at(i).get('value')?.touched &&
                    fields.at(i).get('value')?.errors
                  "
                  class="error-message"
                >
                  <i class="pi pi-exclamation-circle mr-1"></i>

                  Please enter a valid email address
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <button
        pButton
        pRipple
        type="button"
        label="Cancel"
        icon="pi pi-times"
        class="modern-button secondary"
        (click)="ref.close()"
        [disabled]="loading"
      ></button>
      <button
        pButton
        pRipple
        type="submit"
        label="Submit"
        icon="pi pi-upload"
        class="modern-button primary"
        [loading]="loading"
        [disabled]="form.invalid || loading"
      ></button>
    </div>
  </form>
</div>
